<template>
  <div>
    <div class="mb-20 flex flex-v-center" v-if="reports && reports.length">
      <el-select
        v-model="statusFilter"
        placeholder="Filter by status"
        style="width: 220px"
      >
        <el-option label="All" value="all"></el-option>
        <el-option
          :label="`Absent (${statusCounts.absent})`"
          value="absent"
        ></el-option>
        <el-option
          :label="`On Leave (${statusCounts.on_leave})`"
          value="on_leave"
        ></el-option>
      </el-select>
    </div>

    <div class="table" v-if="groupby === 'employee'">
      <el-table
        v-if="!filteredReports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Absentee Reports available."
      >
      </el-table>
      <el-table
        v-else
        v-for="report of filteredReports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.days"
        width="100%"
        v-loading="loading"
        empty-text="No Absentee Reports available."
        class="colored-head"
      >
        <el-table-column :label="getHeader(report)">
          <el-table-column
            sortable
            prop="checkdate"
            label="DATE"
            width="150"
            align="center"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_name"
            label="SHIFT"
            width="180"
            align="center"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_range"
            label="SHIFT RANGE"
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column label="STATUS" align="center" width="140">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row)">
                {{ getStatusLabel(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <div class="table" v-else>
      <el-table
        v-if="!filteredReports.length"
        style="margin-bottom: 20px"
        :data="[]"
        width="100%"
        v-loading="loading"
        empty-text="No Absentee Reports available."
        class="colored-head"
      >
      </el-table>
      <el-table
        v-else
        v-for="report of filteredReports"
        :key="report.pin"
        style="margin-bottom: 20px"
        :data="report.employees"
        width="100%"
        v-loading="loading"
        empty-text="No Absentee Reports available."
      >
        <el-table-column :label="getDateHeader(report.date)">
          <el-table-column prop="employee_details" label="Name" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.name }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="employee_details" label="Pin" width="200">
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.pin }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="custom_employee_id"
            width="200"
            label="Custom Id"
            v-if="
              'custom_employee_id' in reports[0].employees[0].employee_details
            "
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.custom_employee_id || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Grade"
            v-if="'employee_grade' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_grade || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Type"
            v-if="'employee_type' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_type || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Employee Category"
            v-if="
              'employee_category' in reports[0].employees[0].employee_details
            "
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.employee_category || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Mobile Number"
            v-if="'mobile_number' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.mobile_number || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Email"
            v-if="'email' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.email || "NA" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="employee_details"
            width="200"
            label="Department"
            v-if="'department' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.department || "NA" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="employee_details"
            width="200"
            label="Branch"
            v-if="'branch' in reports[0].employees[0].employee_details"
          >
            <template slot-scope="scope">
              <div>
                {{ scope.row.employee_details.branch || "NA" }}
              </div>
            </template>
          </el-table-column>

          <el-table-column
            sortable
            prop="shift_name"
            width="200"
            label="SHIFT"
          ></el-table-column>
          <el-table-column
            sortable
            prop="shift_range"
            width="200"
            label="SHIFT RANGE"
          ></el-table-column>
          <el-table-column label="STATUS" align="center" width="140">
            <template slot-scope="scope">
              <el-tag :type="getStatusTagType(scope.row)">
                {{ getStatusLabel(scope.row) }}
              </el-tag>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  props: ["reports", "groupby", "loading"],
  data() {
    return {
      statusFilter: "all",
    };
  },
  computed: {
    statusCounts() {
      const counts = { absent: 0, on_leave: 0 };

      (this.reports || []).forEach(report => {
        const rows =
          this.groupby === "employee"
            ? report.days || []
            : report.employees || [];
        rows.forEach(row => {
          const status = this.normalizeStatus(row);
          if (status === "on_leave") {
            counts.on_leave += 1;
          } else {
            counts.absent += 1;
          }
        });
      });

      return counts;
    },
    filteredReports() {
      if (this.statusFilter === "all") {
        return this.reports || [];
      }

      return (this.reports || [])
        .map(report => {
          const key = this.groupby === "employee" ? "days" : "employees";
          const rows = (report[key] || []).filter(row => {
            const status = this.normalizeStatus(row);
            return status === this.statusFilter;
          });

          return {
            ...report,
            [key]: rows,
          };
        })
        .filter(report => {
          const key = this.groupby === "employee" ? "days" : "employees";
          return report[key] && report[key].length > 0;
        });
    },
  },
  methods: {
    normalizeStatus(row) {
      const statusValue =
        row.attendance_status ||
        row.status ||
        row.day_status ||
        row.present_status ||
        "";
      const normalized = String(statusValue)
        .toLowerCase()
        .trim();

      if (normalized.includes("leave")) {
        return "on_leave";
      }

      return "absent";
    },
    getStatusLabel(row) {
      return this.normalizeStatus(row) === "on_leave" ? "ON LEAVE" : "ABSENT";
    },
    getStatusTagType(row) {
      return this.normalizeStatus(row) === "on_leave" ? "success" : "danger";
    },
    getHeader(report) {
      return `Employee Name: ${report.employee_details.name} - Pin: ${
        report.employee_details.pin
      }`;
    },

    getDateHeader(date) {
      return `Absentee Report for: ${date}`;
    },
  },
};
</script>
